let systemConfig = window.systemConfig
export default {
  // 项目任务
  project_task: {
    project: 'project',
    projectName: 'project name',
    projectStatus: 'project status',
    addProject: 'add project',
    inputProjectName25: 'please input the project name,limited to 25 words',
    inputProjectName500: 'please input the content,limited to 500 words',
    projectDescription: 'project description',
    placeOnFilePro: 'archived project',
    nowProjectStatus: 'current project status',
    projectProgress: 'project progress',
    genjuTaskProgress: 'automatic calculation according to task completion progress',
    handInput: 'manual input',
    visibleRange: 'visible range',
    notPublic: 'not public:the project is access to those joining the project',
    public: 'public:the project is access to the staff',
    notPublic1: 'not public',
    public1: 'public',
    personInCharge: 'people in charge',
    operationAuth: 'operation authorization',
    useTaskRoleCustom: 'role permissions within a task can be customized',
    addTask: 'add task',
    projectCollaboration: 'project collaboration',
    systemMessage: 'system message prompt',
    projectProMustFill: 'project progress must be filled in positive integer',
    selectSpecificNumber: 'please select the specific number',
    sureDelProject: 'Are you sure about deleting this project?',
    role: 'role',
    task: 'task',
    executor: 'executor',
    creater: 'creater',
    setDeadline: 'set the deadline',
    selectDeadlinetime: 'please select the dead;ine time',
    deadlineMustinteger: 'deadline must be integer',
    sureMovePeopleForPro:
      'Are you sure you want to transfer the project leader?You will be removed after the transfer.',
    remindSet: 'notification settings',
    deadlineTimeRmind:
      'Before the deadline,remind the executor of the task by the following means.',
    taskName: 'task name',
    state: 'state',
    priority: 'priority',
    selectPriority: 'select priority',
    tagUseMoveInfo:
      'The tag has been used by the task in the current project. All tasks in the project will remove the tag after it is removed.',
    startTime: 'Start time',
    deadlineTime: 'Deadline time',
    endTime: 'End time',
    createTime: 'Creat time',
    lookTheTask: 'View the task',
    addGroup: 'Add group',
    editGroup: 'Edit group',
    delGroup: 'Delate group',
    allProject: 'All projects',
    allTask: 'All tasks',
    myResponsible: 'my responsible',
    myJoin: 'my joined',
    myCreated: 'my created',
    haveInHand: 'In-progress',
    notBegin: 'not begin',
    isStop: 'paused',
    isCompleted: 'completed',
    forInspection: 'wait for inspection',
    inspectionReject: 'inspection to reject',
    stop: 'pause',
    stopPro: 'stop the project',
    enable: 'enable',
    enablePro: 'enable the project',
    del: 'delete',
    delPro: 'delete the project',
    projectNowProre: 'current project progress',
    statusProject1:
      'If the project is over, you can archive it. After archiving, the project will not be allowed to edit the task again. Only members will be allowed to view it.',
    statusProject2:
      'If the project is no longer working, you can pause it. After that, the tasks in the project are not allowed to work again, but can be restarted.',
    statusProject3:
      'If the project has been suspended or archived, you can enable it again, after which the tasks in the project can be operated again.',
    statusProject4:
      'If the project is no longer needed, you can delete it and all tasks under the project will be deleted at the same time.',
    completedTask: 'task completed',
    overdue: 'overdue',
    overdueNotStarted: 'overdue does not begin',
    clickChooseTIme: 'click to select time',
    deadlineDate: 'deadline',
    endDate: 'end date',
    startDate: 'start date',
    clickChooseTemplate: 'select the template',
    groupName: 'group name',
    auth: 'authority',
    start: 'start',
    companyOwnerVisible: 'All personnel of the organization are visible.',
    projectMemberVisible: 'Only project members are visible.',
    projectGroup: 'project group',
    projectName25: 'The project name must not be more than 25 words.',
    deadTimeMaxStartTime: 'The deadline must be after the start time.',
    newBuildtGroup: 'the new grouping',
    pleaseSelectDate: 'Please select the date.',
    pleaseSelectpersoanl: 'Please select the person in charge.',
    groupNameRequire: 'Group name required.',
    groupNameNotRepeat: 'Group names cannot be repeated.',
    isDeleteGroup: 'Are you sure you want to delete this item group?',
    projectDesc500: 'Project description must be no more than 500 words.',
    selectTiemMinNowTiem:
      'The selected time is less than the current time, please confirm whether to create?',
    selectTempalte: 'select the tempalte',
    myTempalte: 'my tempalte',
    allTempalte: 'all tempaltes',
    commonTempalte: 'common tempalte',
    afterService: 'after-sales service',
    productDev: 'research and development of products ',
    administrativePersonnel: 'administrative personnel',
    marketingManagement: 'marketing management',
    previewProjectTemplate: 'preview the project template',
    useThisTemplate: 'use this template',
    listView: 'list view',
    kanbanView: 'kanban view',
    calendarView: 'calendar view',
    tableView: 'table view',
    pleaseInputTaskname: 'Please input the task name.',
    activationReason: 'activation reason',
    isActivateThisTask: 'Are you sure you want to activate this task?',
    isCompleteThisTask: 'Are you sure you want to complete this task?',
    createdSubtaskList: 'create a subtask list',
    subTaskList: 'create a subtask list',
    taskList: 'task list',
    createdTaskGroup: 'create task groups',
    taskGroup: 'task groups',
    quoteTemplate: 'quote the template',
    addTaskList: 'add a task list',
    taskListName: 'task list name',
    taskGroupName: 'task group name',
    usePersonnel: 'use personnel',
    preview: 'preview',
    workflow: 'workflow',
    noTemplateSelect: 'No template is available.',
    taskGroupNameInfo1: 'Task group name must be no more than 25 words and must be filled in.',
    listNameInfo1: 'The list name must be no more than 25 words and must be filled in.',
    openTaskDetails: 'Open task details.',
    subClass: 'subclass',
    levelClassOrTask: 'peer classification or task',
    rename: 'rename',
    batchOperation: 'batch operation',
    markMilestone: 'mark the milestone',
    cancelMilestone: 'cancel the milestone',
    taskStopCannotOperation: 'The task is suspended and cannot be operated.',
    taskCompleteCannotOperation: 'The task is complete and cannot be operated.',
    taskTestCannotOperation: 'The task is to be checked and cannot be operated.',
    InputBoxCannotEmpty: 'The input field cannot be empty.',
    cannotCreateNewTask: 'You cannot create a new subtask.',
    placeOnFile: 'archive',
    projectConnotOperation1: 'The project has been filed and cannot do other operation.',
    projectConnotOperation2:
      'The project has been suspended and no other operations can be performed.',
    taskUnderConnotAddClass: 'cannot create a new category under a task',
    pleaseFillACtiveReason: 'Please fill in the reason for activation.',
    pleaseFillEditReason: 'Please fill in the edit reason.',
    pleaseFillClassName: 'Please fill the category name.',
    classDontAgaInput: 'The category name to delete does not match. Please retype it.',
    activeReason: 'active reason',
    editReason: ' edit reason',
    stopReason: 'stop reason',
    haveSubtask: 'There are subtasks to be completed.',
    retract: 'retract',
    addPerformer: 'retract',
    projectLeader: 'project leader',
    notActive: 'not activated',
    delClass: 'delete the class',
    allShare: 'all shares',
    myShare: 'my shares',
    pleaseSelectClass: 'Please select the class.',
    inputDelClassName: 'Please input the category name to delete.',
    chooseClassMove: 'Select the location to which you want to move this category.',
    chooseClassCopy: 'Select the location to which you want to copy this task.',
    tipsTask1: 'Tip: The task、collaborator and subtask will be copied.',
    selectExecutor: 'Pease select the executor.',
    settingTaskRemind: 'set task reminder',
    remindType: 'remind type',
    customRemind: 'custom reminder',
    deadlineTimeRemind: 'deadline time reminder',
    beforeDeadlineTime: 'before deadline',
    minute: 'minute',
    hour: 'hour',
    day: 'day',
    hour1: 'hour',
    minute1: 'minute',
    second: 'second',
    remindTime: 'reminfer time',
    reminder: 'reminder',
    RemindMode: 'reminding mode',
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.en : 'corporate reputation ',
    customRepeatTask: 'custom repetitive tasks',
    repeat: 'Repeat',
    useDay: 'daily',
    useWeek: 'weekly',
    useMonth: 'monthly',
    neverRepeat: 'never repeat',
    frequency: 'frequency',
    week: 'week',
    month: 'month',
    clickChoose: 'Click on the select.',
    over: 'over',
    never: 'never',
    cishu: 'times',
    date: 'date',
    happen: 'happen',
    tipsTask2: 'Tip: Members must bind enterprise WeChat pins or mailboxes to receive alerts.',
    settingRepeatTask: ' set repetitive task',
    moveTask: 'move the task',
    copyTask: 'copy the task',
    delTask: 'delete the task',
    checkOpinion: 'check the opinion',
    className: 'class name',
    belongToTask: 'belong to task',
    parentTaskName: 'parent task name',
    check: 'check',
    subTask: 'subtask',
    subTaskName: 'subtask name',
    addSubTask: 'add the subtask',
    quote: 'quote',
    byQuote: 'be cited',
    onlyParticipantsVisible: 'Visible only to participants.',
    collaborator: 'collaborator',
    projectMembers: 'project members',
    activation: 'activation',
    personalTask: 'personal task',
    dianzang: 'give a like',
    noDianzang: 'No thumb up.',
    editMemberComplete: 'edit member complete',
    sureDelShare: 'Are you sure you want to delete the share?',
    shareRequ: 'Sharing content is required.',
    title100: 'The title should be no more than 100 words.',
    moveTaskComplete: 'move task complete',
    copyTaskComplete: 'copy task complete',
    delAllsubtaskDel: 'After deleting a task, all subtasks are also deleted.',
    subDealtimeMinParentTime:
      'The subtask cutoff time must be less than the primary task cutoff time.',
    sureDelSubtask: 'Are you sure to delete subtasks?',
    sureCancelAssociation: 'Are you sure about canceling the association?',
    cancelAssociationComplete: 'cancel association complete',
    sureActive: 'Are you sure you want to activate it?',
    sureCompleteTask: 'Are you sure you can accomplish this task?',
    pleaseFillInCheckReason: 'Please fill in the reasons for inspection and editing.',
    subtaskName500: 'Subtask names cannot exceed 500 characters and are mandatory.',
    pleaseChoosePer: 'Please choose the personal.',
    choosePer: 'choose the personal',
    sureDelCollaborator: 'Are you sure to delete the collaborator?',
    systemApplication: 'system application',
    name: 'name',
    addRemindPerson: 'add remind person',
    pleaseFillInFrequency: 'please fill in frequency',
    pleaseFillInHappenCishu: 'Please indicate the times of occurrence.',
    dataIncomplete: 'data incomplete',
    frequencyInteger: 'The frequency must be a positive integer.',
    happenCishuInteger: 'The number of occurrences must be a positive integer.',
    pleaseChooseDate: 'please choose date',
    setTimeLessNow: 'Set time less than current time.',
    pleaseRemindTime: 'Please select the reminder time.',
    pleaseDeadTime: 'Please select the deadline.',
    pleaseRemindType: 'Please choose reminder mode.',
    pleaseReminder: 'Please select the person to be reminded.',
    customFields: 'custom fields',
    currentState: 'current state',
    checker: 'checker',
    selectPic: 'select the picture',
    addTag: 'add the tag',
    tag: 'tag',
    relation: 'relation',
    relationTiggerAddTask: 'associate the data that triggers the new task',
    addRelation: 'cancel relation',
    cancelRelation: 'cancel relation',
    describe: 'describe',
    addMoreFields: 'add more fields',
    addDescribe: 'add description',
    enclosure: 'enclosure',
    addEnclosure: 'add enclosure',
    selectRelation: 'select relation',
    firstSelectExecutor: 'Please give priority to the executor.',
    moveMember: 'remove member',
    editProjectAuth: 'edit project authority',
    editProjectRole: 'edit project role',
    starMarkProject: 'starmark project',
    projectShare: 'project share',
    projectShareTo: 'project share to',
    top: 'top',
    cancelTop: 'cancel the top',
    notAddShare: "You haven't added sharing yet.",
    projectGuideMap: 'project mapping',
    timeControl: 'time control',
    baseSetting: 'basic setting',
    projectTag: 'project tag',
    customManage: 'custom management',
    automationManage: 'automated management ',
    exportProjectTask: 'export project tasks',
    saveProjectTemplate: 'save as a project template',
    baseInfo: 'basic information',
    statusSet: 'states',
    ruleSet: 'authorization',
    taskRemind: 'task reminders',
    taskSet: 'task setting',
    taskActiveInput: 'Task reactivation fill in the activation reason.',
    updateDaedlineTimeInput: 'Changing the deadline and filling in the reason for the change.',
    Appearance: 'appearance',
    tagManage: 'tag management ',
    projectSet: 'project setting',
    generalTasks: 'general tasks',
    projectDynamics: 'project dynamic',
    templateName: 'template name',
    mamzuContion1: 'Records that meet the criteria automatically execute the set business process.',
    module: 'module',
    ruleName: 'rule name',
    triggerEvent: 'trigger event',
    projectAutomation: 'project automation',
    sureMoveProjectMember: 'Are you sure you want to remove this project member?',
    nowProjectUnder:
      'There are still tasks to be performed under the project member, please select the handover person below, after the handover can be removed successfully.',
    handoverPerson: 'handover person',
    SelecthandoverPerson: 'select handover person',
    customWorkbench: 'custom workbench',
    timeWorkbench: 'time workbench',
    sureDelProMember: 'Are you sure you want to delete the project member?',
    sureDelThisRule: 'Are you sure you want to delete this rule？',
    projectTask: 'project task',
    automatchTrigger1: 'after the new record saved',
    automatchTrigger2: 'after the edit record saved',
    automatchTrigger3: 'after the new or edit record saved',
    automatchTrigger4: 'completed',
    automatchTrigger5: 'moved',
    automatchTrigger6: 'reactivated',
    automatchTrigger10: 'deleted',
    automatchTrigger7: 'After the fields are automatically updated.',
    automatchTrigger8: 'after deleting the record',
    automatchTrigger9: 'after collection of records (high seas pool)',
    automatchTrigger11: 'Timed trigger',
    allChecked: 'all checked',
    newBuildClass: 'newly-built class',
    addExecutor: 'add executor',
    assignTo: 'assign to',
    pleaseSelectAssignor: 'please select assignor',
    nameIsNotEmpty: 'The name cannot be empty.',
    delList: 'delete the list',
    inputDelListName: 'Please input the name of the list to delete.',
    inputListNameAtypism: 'The list names input are inconsistent.',
    editFolder: 'edit folder',
    delFolder: 'delete folder',
    notAddFolder: "You haven't added the file yet.",
    addFolder: 'add folder',
    nowAddFolder: 'now add folder',
    folderName: 'folder name',
    folderSetting: 'folder setting',
    addSubFolder: 'add subfolder',
    addFile: 'add file',
    sureDelFolder: 'Are you sure you want to delete this folder?',
    sureDelFile: 'Are you sure you want to delete this folder?',
    fileName: 'file name',
    fileType: 'file type',
    fileSize: 'file size',
    uploadPeople: 'upload people',
    uploadTime: 'upload time',
    shareMemberIsNotEmpty: 'The share member cannot be empty.',
    selectActivityArea: 'Please select the activity area.',
    workflowDescription: 'workflow description',
    triggerThisWorkflow: 'The workflow is triggered by the following action.',
    whenZhixingRule: 'When do you want to enforce this rule?',
    condition: 'condition',
    conditionTrigger: 'Conditions determine when a rule is triggered.',
    conditionTriggerNew:
      'Conditions determine when a rule is triggered;You must specify at least one condition.',
    classification: 'classification',
    anyCondition: 'any condition',
    matchingCondition: 'matching condition',
    addMatchingCondition: 'add matching condition',
    selectGroupList: 'Please select the grouping list.',
    executionOperation: 'execut the operation',
    addOperation: 'add operation',
    autoAssignTo: 'automatic allocation to',
    autoJumpTo: 'automatic jump to',
    fieldUpdate: 'field update',
    fieldZhuanhuan: 'field transformation',
    autoFenpei: 'automatic allocation',
    newBuildEmail: 'creat the new email',
    newBuildUpdate: 'creat and update',
    noticeRemind: 'notification reminder',
    newBuildTask: 'creat the task',
    editTask: 'editing the task',
    newBuildUpdateTarget: 'creat and update events',
    modulesToUpdate: 'the module to be updated',
    fieldsToUpdate: 'fields to update',
    updateToValue: 'updated to value',
    constField: 'constant field',
    qutoeField: 'quoted field',
    assignor: 'assignor',
    depMemRole: 'members, departments, roles, multiple choices',
    addMember: 'add members',
    allocationMechanism: 'allocation mechanism',
    polling: 'polling',
    random: ' random',
    insertField: 'insert fields',
    haveHandInput: 'manual input',
    remindUser: 'remind user',
    remindContent: 'remind content',
    inputMaxlength1000: 'Please input words which max length are 1000.',
    higthContionSetting: 'advanced condition setting',
    selectClass: 'select class',
    selectMoudle: 'please select moudle',
    inputRuleName: 'Please fill in the name of the rule.',
    RuleNameCunzai: 'The rule name already exists.',
    selectOnemoudle: 'Please select a module.',
    updateFiledNotEmpty: 'The field to be updated cannot be empty.',
    updateTo: 'update to',
    setExecutionOperation: 'Please Set the execute action.',
    operationDelsetIsgoon: 'This action will permanently delete the setting, whether to continue?',
    all: 'all',
    taskCustom: 'task custom',
    projectTaskImport1: 'Prepare the data to be imported in the format of the data template.',
    projectTaskImport2:
      'Note: the header name in the template cannot be changed, and the header line cannot be deleted.',
    projectTaskImport3: 'Download the data import template.',
    projectTaskImport4: 'Select the data template that you want to import.',
    projectTaskImport5:
      'In the data template, the name of the header field should be consistent with that of the system, and the number of imported rows should not exceed 10000. Please import in batches if the number exceeds 10000.',
    selectFile: 'select a file',
    customSort: 'custom sorting',
    createTimeAse: 'create time ase',
    createTimeDese: 'create time dese',
    editTimeAse: 'edit time ase',
    editTimeDese: 'edit time dese',
    view: 'view',
    todayTask: 'today task',
    tomorrowTask: 'tomorrow task',
    planTask: 'plan task',
    allMemberSee: 'all members visible',
    importDataComplete: 'import data complete',
    setRepeat: 'setting repeat',
    addCollaborator: 'add collaborator',
    delCollaborator: 'remove collaborator',
    addSubTask1: 'add subtask',
    editSubTask: 'edit subtask',
    delSubTask: 'delete subtask',
    onlyCollaboratorShow: 'Only collaborator are visible.',
    fieldNameIsnotEmpty: 'Field names cannot be empty.',
    atLeastoneValue: 'At least one option value needs to exist.',
    numberRuleIsnotEmpty: 'The numbering rule cannot be null.',
    formulaIsnotEmpty: 'The formula cannot be empty.',
    errorSelectExcel: 'Wrong upload, please select Excel file.',
    pleaseUploadTemplate: 'Please upload the template.',
    pleaseInputReason: 'Please input reasons.',
    secondAfter: 'second after',
    projectAuth: 'project authority',
    projectRoleAuth: 'project roles authority',
    projectRoleAuthInfo:
      'Set the operational permissions for matching project tasks for the permissions required for project members to be in different roles within the project.',
    addRoleAuth: 'add roles authority',
    projectRole: 'project roles',
    roleDesc: 'role description',
    uodateMember: 'update member',
    updateTiem: 'update time',
    roleName: 'role name',
    authSet: 'authority setting',
    projectTagManage: 'Effective management of project tasks through tags.',
    editTag: 'edit tag',
    addTag1: 'add tag',
    inputTagName: 'Please input tag name.',
    selectColor: 'select color',
    editClass: 'edit class',
    addClass: 'add class',
    taskAuto: 'task automation',
    sureDelTag: 'Are you sure you want to delete the tag?',
    sureDelClass: 'Are you sure you want to delete the classification?',
    editRoleAuth: 'edit role authority',
    roleNameNotEmpty: 'The role name cannot be empty.',
    addRoleSuccess: 'add role successfully',
    sureDelRole: 'Are you sure to remove the role?',
    addSubclassSuccess: 'add subclass successfully',
    projectTagNotEmpty: 'The project tag name cannot be empty.',
    taskWorkautoInfo:
      'records that meet the criteria automatically execute the set business process',
    repeatSetting: 'Repeat settings',
    remind: 'remind',
    taskDeadline: 'Before the deadline',
    delSetting: 'Delete settings',
    neverGameover: 'Never end',
    targetTime: 'Trigger time',
    managementGroup: 'Management group',
    inspection: 'inspection',
    surveyor: 'surveyor',
    addChecker: 'Add checker',
    saveAndAdd: 'Save and add',
    taskName500Words: 'The task name is mandatory and must not exceed 500 words',
    taskStartEndTimeInfo: 'The task start time must be less than the cutoff time',
    haveFillInNot: 'Some required fields have not been filled in',
    SaveProjectTemplate: 'Save as a project template',
    wechatWork: 'Enterprise wechat',
    dingTalk: 'DingTalk',
    WeChatOfficialAccount: 'WeChat official account',
    // 20210305
    selectproject: 'Select item',
    tasktag: 'Task tag'
  }
}
